import React from 'react'
import {
  Typography,
  Paper,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'

const StockShirtTable = ({ shirt }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, sm: 2.5, md: 3 },
        borderRadius: 2,
        backgroundColor: (theme) =>
          theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(18, 18, 18, 1)',
        border: (theme) =>
          `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
        boxShadow: (theme) =>
          theme.palette.mode === 'light'
            ? '0 2px 8px rgba(0, 0, 0, 0.08)'
            : '0 2px 8px rgba(0, 0, 0, 0.3)',
        mb: { xs: 2, sm: 2.5, md: 3 },
      }}>
      {/* Table Header */}
      <Box sx={{ mb: { xs: 1.5, sm: 2, md: 2.5 } }}>
        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 600,
            color: 'text.primary',
            fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' },
            mb: { xs: 0.5, sm: 0.75, md: 1 },
          }}>
          Table: Shirt Type : {shirt.shirtType}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
          }}>
          {shirt.shirtType}
        </Typography>
      </Box>

      {/* Table */}
      {shirt.tableData && shirt.tableData.length > 0 ? (
        <TableContainer>
          <Table
            sx={{
              '& .MuiTableCell-root': {
                borderColor: (theme) =>
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.08)'
                    : 'rgba(255, 255, 255, 0.12)',
              },
            }}>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? 'rgba(249, 250, 251, 0.5)'
                      : 'rgba(18, 18, 18, 0.5)',
                }}>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    py: { xs: 1, sm: 1.25, md: 1.5 },
                  }}>
                  Size
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    py: { xs: 1, sm: 1.25, md: 1.5 },
                  }}>
                  Registered (pcs)
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    py: { xs: 1, sm: 1.25, md: 1.5 },
                  }}>
                  Received (pcs)
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    py: { xs: 1, sm: 1.25, md: 1.5 },
                  }}>
                  Remaining (pcs)
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    py: { xs: 1, sm: 1.25, md: 1.5 },
                  }}>
                  Progress
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shirt.tableData.map((row) => (
                <TableRow
                  key={row.size}
                  sx={{
                    '&:hover': {
                      backgroundColor: (theme) =>
                        theme.palette.mode === 'light'
                          ? 'rgba(0, 0, 0, 0.02)'
                          : 'rgba(255, 255, 255, 0.02)',
                    },
                  }}>
                  <TableCell
                    sx={{
                      color: 'text.primary',
                      fontSize: {
                        xs: '0.8125rem',
                        sm: '0.875rem',
                        md: '0.9375rem',
                      },
                      py: { xs: 1, sm: 1.25, md: 1.5 },
                    }}>
                    {row.size}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      color: 'text.primary',
                      fontSize: {
                        xs: '0.8125rem',
                        sm: '0.875rem',
                        md: '0.9375rem',
                      },
                      py: { xs: 1, sm: 1.25, md: 1.5 },
                    }}>
                    {row.registered?.toLocaleString() || '0'}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      color: 'text.primary',
                      fontSize: {
                        xs: '0.8125rem',
                        sm: '0.875rem',
                        md: '0.9375rem',
                      },
                      py: { xs: 1, sm: 1.25, md: 1.5 },
                    }}>
                    {row.received?.toLocaleString() || '0'}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      color: 'text.primary',
                      fontSize: {
                        xs: '0.8125rem',
                        sm: '0.875rem',
                        md: '0.9375rem',
                      },
                      py: { xs: 1, sm: 1.25, md: 1.5 },
                    }}>
                    {row.remaining?.toLocaleString() || '0'}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      color: 'text.primary',
                      fontSize: {
                        xs: '0.8125rem',
                        sm: '0.875rem',
                        md: '0.9375rem',
                      },
                      py: { xs: 1, sm: 1.25, md: 1.5 },
                      fontWeight: 600,
                    }}>
                    {row.progress.toFixed(0)}%
                  </TableCell>
                </TableRow>
              ))}
              {/* Total Row */}
              <TableRow
                sx={{
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? 'rgba(249, 250, 251, 0.8)'
                      : 'rgba(18, 18, 18, 0.8)',
                  '&:hover': {
                    backgroundColor: (theme) =>
                      theme.palette.mode === 'light'
                        ? 'rgba(249, 250, 251, 0.8)'
                        : 'rgba(18, 18, 18, 0.8)',
                  },
                }}>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    py: { xs: 1, sm: 1.25, md: 1.5 },
                  }}>
                  Total
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    py: { xs: 1, sm: 1.25, md: 1.5 },
                  }}>
                  {shirt.totalRegistered?.toLocaleString() || '0'}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    py: { xs: 1, sm: 1.25, md: 1.5 },
                  }}>
                  {shirt.totalReceived?.toLocaleString() || '0'}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    py: { xs: 1, sm: 1.25, md: 1.5 },
                  }}>
                  {shirt.totalRemaining?.toLocaleString() || '0'}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    fontSize: {
                      xs: '0.8125rem',
                      sm: '0.875rem',
                      md: '0.9375rem',
                    },
                    py: { xs: 1, sm: 1.25, md: 1.5 },
                  }}>
                  {shirt.totalProgress.toFixed(0)}%
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box
          sx={{
            py: { xs: 4, sm: 5, md: 6 },
            textAlign: 'center',
          }}>
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
            }}>
            No data
          </Typography>
        </Box>
      )}
    </Paper>
  )
}

export default StockShirtTable
